import { render } from "./PerformanceTrackers.vue?vue&type=template&id=37a13c2b"
import script from "./PerformanceTrackers.vue?vue&type=script&lang=js"
export * from "./PerformanceTrackers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__